import PhoneTable from "/src/features/administration/phone/components/PhoneTable/PhoneTable";
function PhoneList() {

    return <PhoneTable/>
}

export default PhoneList;